import $ from "jquery"

const Config = {
	debug: false,
	version: version,
	env: env,
	proxy: "",
	publicPath: "typo3conf/ext/" + publicPath + "/Resources/",
	documentRoot: "/",
}

export default $.extend(true, Config, window.bbConfig)
